import axios from "axios";
import { getToken } from "./auth";

// export const baseURL = "https://ccmlogistics-backend.insignio.tech";
// export const baseURL = "http://localhost:8000";
export const baseURL = "https://crm-backend.ccmlogistics.co.za";


const api = axios.create({
  baseURL: baseURL + "/api",
});

export const INSIGAPI = axios.create({
  // baseURL: "https://comcapital-backend.insignio.tech/api",
  // baseURL: "http://localhost:8001/api",
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
